console.log([NODE_ENV_SHORT, PACKAGE_VERSION, COMMIT_ID, BUILD_DATE].join('/'));
if (DEVELOPMENT) {
    console.log('https://tudoku.papergame.ru/tudoku/admin');
}
